import PropTypes from "prop-types";
import classNames from "classnames";
import "./SeparatorLine.scss";

const SeparatorLine = ({ vertical = false, decorative = true, className, label, ...props }) => {
	const ariaAttributes = decorative
		? { "aria-hidden": "true" }
		: { ...(label && { "aria-label": label }) };

	if (vertical) {
		ariaAttributes["aria-orientation"] = "vertical";
	}

	const separatorClassName = classNames(
		"separator-line",
		{
			"separator-line--vertical": vertical,
			"separator-line--horizontal": !vertical,
		},
		className
	);

	return <hr className={separatorClassName} {...ariaAttributes} {...props} />;
};

SeparatorLine.propTypes = {
	vertical: PropTypes.bool,
	decorative: PropTypes.bool,
	className: PropTypes.string,
	label: PropTypes.string,
	color: PropTypes.string,
};

export default SeparatorLine;
